import styled from 'styled-components/macro'

export const FeedStatusSC = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto 1fr;
  grid-column-gap: 18px;
  font-weight: bold;

  & svg {
    align-self: center;
  }

  p {
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
  }
`

export const NoteSC = styled.div`
  font-size: 14px;
  grid-column: 2;
  font-weight: 400;
`
